module.exports = __webpack_public_path__ + "modify.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modify.png
// module id = 23
// module chunks = 0